import { Injectable } from '@angular/core';
import { ContactType } from './contact-type.model';
import { IContactTypeService } from './icontact-type.service';
import { ApiService, ApiCacheOptions, PagedResultGeneric } from '../../../shared/index';
import { PagedResult as GenericPagedResult } from '../../../shared/model/generic-paged-result.model';
import { ContactTypeSearchParams } from '../search/contact-type-search-params.model';

@Injectable()
export class ContactTypeService implements IContactTypeService {
  private _cacheOptions: ApiCacheOptions;
  public constructor(private _apiService: ApiService) {
    this._cacheOptions = this._apiService.getDefaultApiCacheOptionsForInfrequentlyChangedData();
  }

  getContactType = (contactType: string): Promise<ContactType> => {
    let encodedContactType = encodeURIComponent(contactType);
    let url: string = `/ContactType?contactType=${encodedContactType}`;
    return this._apiService.get(url, this._cacheOptions);
  };

  getContactTypes(searchParams: any, forceRefresh?: boolean): Promise<GenericPagedResult<ContactType[]>> {
    let url: string = '/ContactTypes';
    const cacheOptions = forceRefresh ? this._apiService.getDefaultApiCacheOptionsForNoCache() : this._cacheOptions;
    return this._apiService.getPaged(url, searchParams, cacheOptions);
  }

  updateContactType(contactType: ContactType, oldContactType: string): Promise<void> {
    let encodedOldContactType = encodeURIComponent(oldContactType);
    let url: string = `/ContactType?contactTypeName=${encodedOldContactType}`;
    return this._apiService.put(url, contactType);
  }

  insertContactType(contactType: ContactType): Promise<string> {
    let url: string = '/ContactTypes';
    return this._apiService.post(url, contactType);
  }

  deleteContactType(contactType: string): Promise<void> {
    let encodedContactType = encodeURIComponent(contactType);
    let url: string = `/ContactType?contactType=${encodedContactType}`;
    return this._apiService.delete(url);
  }
}
